// eslint-disable-next-line import/prefer-default-export
export function setUnreadCount (state, value) {
    state.unreadCount = value;
}

export function setChats (state, value) {
    state.chats = value;
}

export function setUnreadCountNew (state, { chatId, count }) {
    state.chatsUnread[chatId] = count;
}

export function incUnreadCount (state, chatId) {
    const { chatsUnread } = state;
    chatsUnread[chatId] = (chatsUnread[chatId] || 0) + 1;
}

export function setUnreadTotal (state, value) {
    state.unreadTotal = value;
}
